import React from "react";

// One-tap "Continue with Google" — kicks the browser to Emergent's
// hosted Google OAuth, which lands the user back at
// /auth/google/callback#session_id=… The callback page does the actual
// session exchange via /api/auth/google/session-exchange.
//
// Visual: matches Google's brand guidelines for OAuth buttons (white
// background, dark text, multi-color "G" mark, no other Google logos).
const GoogleAuthButton = ({ label = "Continue with Google" }) => {
  const handleClick = () => {
    const origin = window.location.origin;
    // Where Emergent should send the user after Google approves.
    const redirect = `${origin}/auth/google/callback`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full flex items-center justify-center gap-2.5 bg-white hover:bg-gray-100 text-gray-800 font-medium py-2.5 rounded-md transition-colors border border-gray-300"
      data-testid="continue-with-google-btn"
      aria-label={label}
    >
      <GoogleGIcon />
      <span className="text-sm">{label}</span>
    </button>
  );
};

const GoogleGIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.616z"
    />
    <path
      fill="#34A853"
      d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A9 9 0 009 18z"
    />
    <path
      fill="#FBBC05"
      d="M3.964 10.707A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.707V4.961H.957A9 9 0 000 9c0 1.452.348 2.827.957 4.039l3.007-2.332z"
    />
    <path
      fill="#EA4335"
      d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A9 9 0 00.957 4.961L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
    />
  </svg>
);

export default GoogleAuthButton;
